import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import Container from '../components/ui/Container';
import Button from '../components/ui/Button';
import SectionHeader from '../components/ui/SectionHeader';
import ThemeStrip from '../components/sections/ThemeStrip';
import TechApproach from '../components/sections/TechApproach';
import CTABanner from '../components/sections/CTABanner';
import './About.css';

const PILLARS = [
  {
    eyebrow: 'Mission',
    title: '사람들이 실제로 쓰는 서비스를 만듭니다.',
    body:
      '아이디어가 좋은지는 만들어서 내놓기 전까지 알 수 없다고 봅니다. 그래서 오래 다듬는 대신 빨리 만들어 사람들 앞에 두고, 쓰이는지 확인한 뒤 고칩니다. 쓰이지 않으면 접습니다.',
  },
  {
    eyebrow: 'Vision',
    title: '작은 팀이 더 많은 서비스를 만들 수 있게 합니다.',
    body:
      'AI 에이전트를 개발 과정에 넣으면 사람 수보다 많은 일을 할 수 있습니다. 우리는 그 방식을 다른 회사에 팔기 전에 우리 제품에 먼저 적용하고 있습니다.',
  },
];

const COMPANY_INFO = [
  { term: '회사명', desc: 'Flowto.AI (플로우투에이아이)' },
  { term: '하는 일', desc: 'AI 프로덕트 스튜디오 — 모바일 앱과 웹 서비스 개발·운영' },
  { term: '위치', desc: '서울, 대한민국' },
  { term: '문의', desc: 'flowtosupport@gmail.com', href: 'mailto:flowtosupport@gmail.com' },
];

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="about-page">
      <SEO
        title="회사 소개"
        description="Flowto.AI는 AI 프로덕트 스튜디오입니다. 에이전트 오케스트레이션으로 빠르게 만들고, 게이미피케이션으로 계속 쓰게 만들고, 만들기 전에 검증합니다."
        url="/about"
      />

      <header className="about-hero">
        <Container>
          <span className="about-hero__eyebrow">About</span>
          <h1 className="about-hero__title">
            AI로 일상에서 쓰는
            <br />
            <span className="about-hero__title-grad">서비스를 만듭니다.</span>
          </h1>
          <p className="about-hero__sub">
            Flowto.AI는 서울에 있는 작은 프로덕트 스튜디오입니다. 여행, 건강·습관,
            비즈니스 검증, 생활 도구 — 네 가지 영역에서 서비스를 만들고 있습니다.
          </p>
        </Container>
      </header>

      <section className="about-pillars">
        <Container>
          {PILLARS.map((p) => (
            <article key={p.eyebrow} className="about-pillar">
              <SectionHeader eyebrow={p.eyebrow} title={p.title} />
              <p className="about-pillar__body">{p.body}</p>
            </article>
          ))}
        </Container>
      </section>

      <TechApproach />

      <ThemeStrip />

      <section className="about-more">
        <Container>
          <Button
            as={Link}
            to="/products"
            variant="outline"
            size="md"
            pill
            iconRight={<ArrowRight size={16} strokeWidth={2.5} />}
          >
            프로덕트 자세히 보기
          </Button>
        </Container>
      </section>

      <section className="about-info">
        <Container>
          <SectionHeader eyebrow="Company" title="회사 정보" />
          <dl className="about-info__list">
            {COMPANY_INFO.map((row) => (
              <div key={row.term} className="about-info__row">
                <dt>{row.term}</dt>
                <dd>
                  {row.href ? <a href={row.href}>{row.desc}</a> : row.desc}
                </dd>
              </div>
            ))}
          </dl>
        </Container>
      </section>

      <CTABanner />
    </div>
  );
};

export default About;
